var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2864 6.20508H11.462C11.2827 6.20508 11.1122 6.29121 11.0067 6.43887L8.2434 10.2709L6.99183 8.53418C6.88636 8.38828 6.71761 8.30039 6.53655 8.30039H5.71214C5.59788 8.30039 5.53108 8.43047 5.59788 8.52363L7.78812 11.5611C7.83986 11.6334 7.90807 11.6922 7.98709 11.7328C8.06612 11.7734 8.15368 11.7946 8.24252 11.7946C8.33136 11.7946 8.41892 11.7734 8.49794 11.7328C8.57696 11.6922 8.64517 11.6334 8.69691 11.5611L12.3989 6.42832C12.4674 6.33516 12.4006 6.20508 12.2864 6.20508Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125ZM9 15.5391C5.38945 15.5391 2.46094 12.6105 2.46094 9C2.46094 5.38945 5.38945 2.46094 9 2.46094C12.6105 2.46094 15.5391 5.38945 15.5391 9C15.5391 12.6105 12.6105 15.5391 9 15.5391Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.6565a5fc0c2125b396ba4bd97b25b3cb.svg";
export { ForwardRef as ReactComponent };